import { render, staticRenderFns } from "./SequenceEditor.vue?vue&type=template&id=63944e86&scoped=true&"
import script from "./SequenceEditor.vue?vue&type=script&lang=js&"
export * from "./SequenceEditor.vue?vue&type=script&lang=js&"
import style0 from "./SequenceEditor.vue?vue&type=style&index=0&id=63944e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63944e86",
  null
  
)

export default component.exports